
<!-- confirmation MODAL -->
<p-dialog 
  [header]="title" 
  [modal]="true"
  [closable]="false"
  [(visible)]="visible"
  styleClass="p-confirm-dialog">

  <div>
    {{message}}
  </div>

  <ng-template pTemplate="footer">
        <button pButton [label]="cancelText" (click)="onCancelClicked()" class="p-button-outlined"></button>
        <button pButton [label]="confirmText" (click)="onConfirmClicked()"></button>
  </ng-template>

</p-dialog>